import { render, staticRenderFns } from "./downloadInvoice.vue?vue&type=template&id=34ea0441"
import script from "./downloadInvoice.vue?vue&type=script&lang=ts"
export * from "./downloadInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports